import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactDatatable from "@ashvin27/react-datatable";
import ApiConnect from "../../../../Utils/ApiConnect";
import { toast } from "react-toastify";
import DeletePop from "../../../Components/DeletePop";
import FileViewer from "../../../Components/FileViewer";
export default function Brands() {
  const BrandsList = useSelector((state) => state.Inventory.Brands);
  const [showModal, setShowmodal] = useState(false);
  const [Brandsname, setBrandsName] = useState("");
  const [brandImages, setBrandImages] = useState([]);
  const [previewImage, setPreviewImage] = useState([]);
  const [bid, setBid] = useState("");
  const [btnDisable, SetbtnDisbale] = useState(false);
  const [modalName, setModalName] = useState("");
  const [formError, setFormError] = useState(false);
  const [selectedId, SetselectedId] = useState(false);
  const [triggerModal, SettriggerModal] = useState(false);
  const [showFileModal, SetFilemodal] = useState(false);
  const [selectedFile, SetselectedFile] = useState(false);
  const fetchHandler = (id) => {
    ApiConnect.get(`/Module/Inventory/Brand/Details?id=${id ? id : ""}`)
      .then((response) => {
        if (id) {
          setBrandsName(response.data.name);
          setPreviewImage(response.data.image);
        } else {
          let Brand = response.data;
          dispatch({ type: "SET_INVENTORY_BRANDS", payload: { Brand } });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchHandler();
  }, []);
  const handleModalClose = () => {
    setShowmodal(false);
  };
  const handleModalOpen = (e, id) => {
    setModalName(e);
    setBrandsName("");
    setPreviewImage([]);
    setBrandImages([]);
    setShowmodal(true);
    if (id) {
      setBid(id);
      fetchHandler(id);
    }
  };
  const imageHandleChange = (e) => {
    if (e.target.files) {
      const fileArray = Array.from(e.target.files).map((file) =>
        URL.createObjectURL(file)
      );
      setBrandImages(e.target.files[0]);
      setPreviewImage(fileArray);
    }
  };
  const submitHandler = (e, type) => {
    e.preventDefault();
    SetbtnDisbale(true);
    let formData = new FormData();
    formData.append("id", bid);
    formData.append("name", Brandsname);
    formData.append("images_files", brandImages);
    ApiConnect({
      method: "post",
      url: `/Module/Inventory/Brand/${type}Brand`,
      data: formData,
    })
      .then((response) => {
        SetbtnDisbale(false);
        if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          setBrandsName("");
          setPreviewImage([]);
          setBrandImages([]);
          handleModalClose();
          fetchHandler();
        } else {
          setFormError(response.data.message);
        }
      })
      .catch((error) => console.log(error));
  };
  const dispatch = useDispatch();
  const columns = [
    {
      key: "name",
      text: "Brands",
      sortable: true,
      cell: (record) => {
        return (
          <div className="media d-inline-flex">
            <img
              className="avatar avatar-lg"
              src={record.image[0]}
              alt={record.name}
              onClick={() => {
                SetselectedFile(record.image[0]);
                SetFilemodal(true);
              }}
            />
            <div className="media-body">
              <p className="lh-1">{record.name}</p>
              <small>{record.id}</small>
            </div>
          </div>
        );
      },
    },
    {
      key: "product",
      text: "Total Product",
      sortable: true,
    },
    {
      key: "action",
      text: "Action",
      className: "table-actions",
      width: 150,
      sortable: false,
      align: "center",
      cell: (record) => {
        return (
          <React.Fragment>
            <button
              className="table-action btn btn-square btn-pure hover-warning"
              onClick={() => handleModalOpen("Edit", record.id)}
            >
              <span className="material-icons-outlined">edit_note</span>
            </button>
            <button
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetselectedId(record.id);
                SettriggerModal(true);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
  ];
  const config = {
    key_column: "id",
    page_size: 30,
    length_menu: [30, 60, 90],
    show_filter: true,
    show_pagination: true,
    button: {
      // excel: true,
      // print: true
    },
    language: {
      loading_text: "Please be patient while data loads...",
    },
  };

  const SetviewerTrigger = () => {
    SetFilemodal(false);
  };
  return (
    <div className="p-0 m-0">
      <header className="header no-border">
        <div className="header-info">
          <div className="left">
            <h2 className="header-title">
              <strong>Brands</strong>
              <small className="subtitle">
                Here you can edit,delete,view Brands.
              </small>
            </h2>
          </div>
          <div className="right gap-items-2">
            <button
              className="btn btn-primary  btn-float btn-round"
              onClick={(e) => handleModalOpen("New")}
            >
              <span className="material-icons-outlined">add</span>
            </button>
          </div>
        </div>
      </header>

      <div className="container">
        <div className="col-md-12 col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="dataTables_wrapper">
                <ReactDatatable
                  className="table table-separated"
                  config={config}
                  records={BrandsList}
                  columns={columns}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        className="modal-center"
        onHide={(e) => handleModalClose()}
      >
        <Modal.Dialog>
          <Modal.Header>
            <h5 className="modal-title">{modalName} Brands</h5>
            <button
              type="button"
              className="btn"
              onClick={(e) => handleModalClose()}
            >
              <span>×</span>
            </button>
          </Modal.Header>
          <form onSubmit={(e) => submitHandler(e, modalName)}>
            <Modal.Body>
              <p className="text-danger">{formError}</p>
              <label className="form-label">Brands Name</label>
              <label className="col-12">
                <input
                  type="text"
                  value={Brandsname}
                  className="form-control"
                  name="name"
                  required="required"
                  onChange={(e) => setBrandsName(e.target.value)}
                />
              </label>
              <label className="form-label">Brand Images</label>
              <div className="file-group">
                <input
                  type="file"
                  id="file"
                  multiple
                  accept="image/*"
                  onChange={(e) => imageHandleChange(e)}
                />
                <label htmlFor="file">
                  <span className="material-icons-outlined">upload_file</span>
                </label>
              </div>
              <div className="row">
                {previewImage.map((image, index) => (
                  <div className="col" key={index}>
                    <img
                      className="img-thumbnail"
                      width="150"
                      src={image}
                      alt={`Brand${index}`}
                    />
                  </div>
                ))}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="submit"
                className="btn btn-success"
                disabled={btnDisable}
              >
                {modalName === "New" ? "Save" : "Edit"}
              </button>
            </Modal.Footer>
          </form>
        </Modal.Dialog>
      </Modal>
      <DeletePop
        trigger={triggerModal}
        delUrl={`/Module/Inventory/Brand/Delete?id=${selectedId}`}
        hideTrigger={SettriggerModal}
        fallAction={fetchHandler}
      />
      <FileViewer
        trigger={showFileModal}
        doc={selectedFile}
        hideTrigger={SetviewerTrigger}
      />
    </div>
  );
}
